export default "__VITE_ASSET__yFkjkIDx__"